import axios from "axios";
import qs from "qs";
import moment from "moment";

export enum ExperimentNavType {
    allTest,
    myOrder
}

export enum ExperiState {
    Idle = 0, //未开始
    InProgress = 1, //进行中
    Done = 2 //结束
}

export enum ExperiNavState {
    introduction = 0, //项目介绍
    software = 1, //安装软件
    planList = 2 //预约计划
}

export const ExperiStateMap = {
    [ExperiState.Idle]: "未开始",
    [ExperiState.InProgress]: "进行中",
    [ExperiState.Done]: "已结束"
};

export interface CloudDeskExperimentListItem {
    id: number; //项目ID
    projectName: string; //项目名称
    cloudGuid: string; //云ID
    projectIntroduce: string; //项目说明
    projectNo: string; //项目编号
    createUser?: string;
    updateUser?: string;
    createTime: string;
    updateTime: string;
}

/**
 * 实验项目列表
 * @param search
 */
export function getCloudDeskExperimentList(search?: string) {
    return axios
        .post<SuccessData<CloudDeskExperimentListItem[]>>(
            "/student/cloudDeskTop/getCloudDeskExperimentList",
            qs.stringify({ search })
        )
        .then(res => res.data.data);
}

export enum ExperiState {
    noStart = 0, //未开始
    doing = 1, // 进行中
    done = 2 // 已结束
}

export interface ExperimentListItem {
    planName: string; //计划名称
    id: number; //计划ID
    useCount: number; //使用人数
    beginTime: string; //开始时间
    endTime: string; //结束时间
    projectName: string; //项目名
    osName: string; //操作系统
    url: string; //前往实验URL
    status: ExperiState; // 计划状态 : 0:未开始 1:进行中 2:已结束
}

/**
 * 查询全部计划
 */
export function getMyExperimentAllList(search?: string) {
    return axios
        .post<SuccessData<ExperimentListItem[]>>(
            "/student/cloudDeskTop/getMyExperimentAllList",
            qs.stringify({ search })
        )
        .then(res => res.data.data);
}

export function goToExperimentUrl(url: string) {
    window.open(url);
}

export interface ExperimentInfo {
    projectNo: string; //项目编号
    softWare: string; //软件安装
    createTime: string;
    updateTime: string;
    id: number; //项目ID
    projectName: string; //项目名
    osName: string; //操作系统
    cloudGuid: string; //云ID
    projectIntroduce: string; //项目说明
    nameLabel: string;
}

/**
 * 具体实验项目详情
 */
export function getExperimentInfo(experimentId: string) {
    return axios
        .post<SuccessData<ExperimentInfo>>(
            "/student/cloudDeskTop/getExperimentInfo",
            qs.stringify({ experimentId })
        )
        .then(res => res.data.data);
}

/**
 * 项目下的学生预约实验列表
 */
export function getMyExperimentByEIdList(experimentId: string) {
    return axios
        .post<SuccessData<ExperimentListItem[]>>(
            "/student/cloudDeskTop/getMyExperimentByEIdList",
            qs.stringify({ experimentId })
        )
        .then(res => res.data.data);
}

interface ExperiForm {
    planName: string; //计划名
    useCount: number; //使用个数
    projectName: string; //项目名
    beginTime: string; //开始时间
    endTime: string; //结束时间
    osName: string; //操作系统
    installingSoftware: string; //软件安装
    cloudDeskExpId: number; //项目id
    cloudGuid: string; //云id
}

/**
 * 预约实验
 */
export function createExperiment(params: ExperiForm) {
    const data = {
        ...params,
        planName:
            params.planName.trim().length === 0
                ? moment().format("MM-DD HH:mm") + " 实验计划"
                : params.planName.trim()
    };

    return axios
        .post<SuccessData<ExperiForm>>(
            "/student/cloudDeskTop/createExperiment",
            qs.stringify(data)
        )
        .then(res => res.data.data);
}

/**
 * 取消预约
 */
export function cancelCloudDesk(planId: number) {
    return axios
        .post("/student/cloudDeskTop/cancelCloudDesk", qs.stringify({ planId }))
        .then(res => res.data.data);
}

/**
 * 删除计划
 */
export function removeCloudDeskTop(planId: number) {
    return axios
        .post(
            "/student/cloudDeskTop/removeCloudDeskTop",
            qs.stringify({ planId })
        )
        .then(res => res.data.data);
}

export interface CloudInfoListItem {
    OrderGuid: string; //orderId
    BeginDay: string; //开始日期
    EndTime: string; //结束时间
    Used: number; //已使用
    Total: number; //剩余
    CanUse: number;
    BeginTime: string;
    ShortTime: string;
    CloudGuid: string; //云ID
    EndDay: string; //结束时间
    Count: number;
}

interface CloudInfoList {
    CloudTotal: string; //当前实验总数
    OrderList: CloudInfoListItem[];
}

/**
 * 查看资源
 */
export function getCloudInfoList(
    cloudGuid: string,
    beginTime: string,
    endTime: string
) {
    return axios
        .post<SuccessData<CloudInfoList>>(
            "/student/cloudDeskTop/getCloudInfoList",
            qs.stringify({ cloudGuid, beginTime, endTime })
        )
        .then(res => res.data.data);
}
